<template>
  <div class="container" >
    <div class="row">
      <div class="col-12">
        <button class="col-3 float-end btn btn-success" v-on:click="create">Create Server</button>
      </div>
    </div>
  </div>
  <DataTable2
      :headers="headers"
      :actions="actions"
      :api="getServers"
      :trigger="trigger"
      :fields="['name']"
  />
  <terminal v-bind:terminal="terminal"></terminal>
  <div class="container">
    <div class="row">
        <button class="btn btn-success"
                v-on:click="terminal.isShow=true"
                v-if="!terminal.isShow">Open Terminal</button>
    </div>
  </div>
</template>

<script>
import DataTable2 from 'data-table/src/components/DataTable2'
import Terminal from "../components/Terminal";
import {api} from "../services/api";
import InsertModalService from "modal/src/services/InsertModal";
import ModalService from "modal/src/services/Modal";
import toastService from "toast/src/services/toast";

export default {
  name: "Server",
  components: {Terminal, DataTable2},
  methods:{
    refresh() {
      if(this.trigger.refresh != null)
        this.trigger.refresh();
    },
    async upsert(server,message){
      await api.servers.post("",server);
      if(!server._id) {
        this.refresh();
      }
      toastService.Notify({
        title:"Success",
        message:`You've successfully ${message} an item.`,
        imgSrc:"/egc.png"
      })
    },
    getServers(filter,skip,limit) {
      return api.servers.post("get",{
        filter,skip,limit
      });
    },
    create() {
      InsertModalService.Show({
        title:`Create Server`,
        type: this.type,
        model: {}
      },(Server) => {
        this.upsert(Server,"create")
      });
    },
    edit(server) {
      InsertModalService.Show({
        title:`Edit Server`,
        type: this.type,
        model: server
      },(entity) => {
        this.upsert(entity,"edit");
      });
    },

    remove(server) {
      ModalService.Show({
        title:`"Delete Server`,
        message:`Do you really want to delete ${server.name}?`,
      },async () => {
        await api.servers.delete(server._id);
        this.refresh();
        toastService.Notify({
          title:"Success",
          message:"You've successfully delete an item.",
          imgSrc:"/egc.png"
        })
      });
    }
  },
  data() {
    return {
      trigger:{},
      terminal:{isShow:false},
      type: {name:"name",hostname:"text",username:"username",directory:"directory",pem:"text"},
      headers: {
        "_id" : "#",
        "name" : "Name",
        "hostname" : "Host Name",
        "username": "User",
        "pem":"Pem"
      },
      actions: [
        {
          classNames:"fa fa-pen text-success",
          callback: this.edit
        },
        {
          classNames:"fa fa-trash text-danger",
          callback: this.remove
        }
      ]
    }
  }
}
</script>